import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-download',
  templateUrl: './single-download.component.html',
  styleUrls: ['./single-download.component.scss']
})
export class SingleDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
